  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyCbo3IZPg7KjuwrYow9NQu7ls__SqUJtSM",
  authDomain: "ada4-b7daa.firebaseapp.com",
  projectId: "ada4-b7daa",
  storageBucket: "ada4-b7daa.firebasestorage.app",
  messagingSenderId: "449270555812",
  appId: "1:449270555812:web:70c9b532a779e8a7ffb231",
  measurementId: "G-4CLYQSWZ23"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
